<template>
  <div class="modal fade bd-example-modal-lg" :id="dataTarget" tabindex="-1"
       role="dialog" :aria-labelledby=selector
       aria-hidden="true" @hide="cancel">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title font-weight-600" :id=selector>更新數量</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body p-0">
          <div class="mt-3"/>

          <div class="row m-0 px-3">
            <WatermarkImage v-if="img" class="col-lg-2 col-md-6 col-sm-12 p-0 rounded-3">
              <img class="w-100 rounded-3" :src="getMediaUrl(img)">
            </WatermarkImage>
            <TagItem v-if="!is_stock" :text="'預訂'" :color="'red'" class="position-absolute"
                     style="top: 25px; left: 25px"/>

            <div class="col-lg-10 col-md-6 col-sm-12 px-md-3 px-0">
              <span
                  class="text-custom-text font-weight-500 h4 font-weight-600">{{ title }}</span>
              <div class="mt-1"/>
              <div class="d-flex grid-gap">
                <TagItem v-if="is_new" :text="'最新'" :color="'yellow'" />
                <div v-for="(item, index) in tag_list" :key="index">
                  <TagItem :text="item.text" :color="item.color"></TagItem>
                </div>
              </div>
            </div>

          </div>

          <div class="mt-1"/>

          <div v-if="note" class="row m-0 px-3">
            <TagItem :text="'備註'" :color="'white'"></TagItem>
            <div class="ml-1"></div>
            <div class="text-main-color font-size-16">{{ note }}</div>
          </div>

          <hr class="my-3">

          <div class="row m-0 align-items-center justify-content-lg-start justify-content-center">
            <div class="col-lg-6 col-sm-12 text-custom-text text-left font-weight-600">規格</div>
            <div class="row col-lg-6 col-sm-12 justify-content-end ">
              <button
                  type="button"
                  size="sm"
                  class="btn btn-main-color col unit-readonly-btn"
                  style="max-width: 170px"
                  v-for="(item, index) in unit_list"
                  :key="index"
                  v-text="item.amount +'PCS/'+item.text"
                  disabled
              />
            </div>
          </div>

          <div class="mt-2"/>

          <div class="row m-0 align-items-center justify-content-lg-start justify-content-center">
            <div class="col-lg-7 col-sm-12 text-custom-text text-left font-weight-600">數量</div>
            <div class="row col-lg-5 col-sm-12 align-items-center justify-content-lg-end  justify-content-center  ">
              <base-button class="m-0" size="sm" type="main-color" icon="fa fa-minus" @click="dec"/>
              <input
                type="number"
                class="text-center col-8 form-control quantity-input"
                v-model.number="operate_amount"
                :step="operate_unit_type && operate_unit_type.unit_count ? operate_unit_type.unit_count : 1"
                :min="0"
                :max="Math.floor(999 / (operate_unit_type && operate_unit_type.unit_count ? operate_unit_type.unit_count : 1)) * (operate_unit_type && operate_unit_type.unit_count ? operate_unit_type.unit_count : 1)"
                inputmode="numeric"
                aria-label="調整數量"
                @input="onOperateAmountInput"
                @blur="onOperateAmountBlur"
                @keydown.enter.prevent="onOperateAmountEnter"
              />
              <base-button class="m-0" size="sm" type="main-color" icon="fa fa-plus" @click="add"/>
            </div>
          </div>


          <hr class="my-3">

          <div class="row m-0 ">
            <div class="col-6 text-custom-text font-weight-600">總下單數量</div>
            <div class="col-6 text-right text-custom-text">{{ total_amount }} PCS</div>
          </div>
          <div class="mt-1"/>
          <div v-if="commodity_price_calc_type !== 'sell_price'" class="row m-0 ">
            <div class="col-6 text-custom-text font-weight-600">總價</div>
            <div class="col-6 text-right text-custom-text">{{ formatMonetaryTypeName(official_monetary_type_id) }}
              {{ formatMonetaryTypePrefix(official_monetary_type_id) }}{{ fmt(total_price) }}
            </div>
          </div>
          <div class="mt-1"/>
          <div v-if="commodity_price_calc_type === 'sell_price'" class="row m-0 ">
            <div class="col-6 text-custom-text font-weight-600">售價</div>
            <div class="col-6 text-right text-custom-text">{{ formatMonetaryTypeName(sell_monetary_type_id) }}
              {{ formatMonetaryTypePrefix(sell_monetary_type_id) }}{{ fmt(total_price) }}
            </div>
          </div>
          <div v-else-if="commodity_price_calc_type === 'exchange_rate_discount'" class="row m-0 ">
            <div class="col-6 text-custom-text font-weight-600">匯率折扣</div>
            <div class="col-6 text-right text-orange">{{ formatMonetaryTypeName(official_monetary_type_id) }}
              {{ discount > 100 ? '+' : '-' }}{{ formatMonetaryTypePrefix(official_monetary_type_id) }}{{ fmt(Math.abs(discount_price)) }}
            </div>
          </div>
          <div class="mt-1"/>
          <div v-if="is_combine_buy" class="row m-0 ">
            <div class="col-6 text-custom-text font-weight-600 ">湊箱折扣</div>
            <div v-if="commodity_price_calc_type === 'exchange_rate_discount'" class="col-6 text-right text-orange">{{ formatMonetaryTypeName(official_monetary_type_id) }}
              -{{ formatMonetaryTypePrefix(official_monetary_type_id) }}{{ fmt(combine_buy_discount_price) }}
            </div>
            <div v-else class="col-6 text-right text-orange">{{ formatMonetaryTypeName(1) }}
              -{{ formatMonetaryTypePrefix(1) }}{{ fmt(combine_buy_discount_price) }}
            </div>
          </div>
          <div class="mt-1"/>
          <div v-if="commodity_price_calc_type === 'exchange_rate_discount'" class="row m-0 ">
            <div class="col-6 text-custom-text font-weight-600">預估匯率</div>
            <div class="col-6 text-right text-custom-text">{{ fmtRate(exchange_rate) }}</div>
          </div>
          <div v-else-if="commodity_price_calc_type === 'sale_price_discount'" class="row m-0 ">
            <div class="col-6 text-custom-text font-weight-600">售價折扣</div>
            <div class="col-6 text-right text-custom-text">{{ fmt(discount > 1 ? discount / 100 : discount) }}</div>
          </div>

          <hr class="my-3">

          <div class="row m-0 ">

            <div class="col-6">
              <div class="h5 m-0 text-custom-text font-weight-600">
                預估到貨價
              </div>
              <div v-if="commodity_price_calc_type === 'exchange_rate_discount'" class="text-custom-description">
                (預估到貨價 = {{ formatMonetaryTypeName(official_monetary_type_id) }} x 折扣 x 發貨日匯率)
              </div>
              <div v-else-if="commodity_price_calc_type === 'sale_price_discount'" class="text-custom-description">
                (預估到貨價 = {{ formatMonetaryTypeName(official_monetary_type_id) }} x 售價折扣)
              </div>
              <div v-else class="text-custom-description">
                (預估到貨價 = 售價)
              </div>
            </div>

            <div class="col-6 text-right text-custom-text-2 ">
              <div class="h6 m-0 font-weight-600">約TWD</div>
              <div class="h3 m-0 font-weight-600">
                {{ fmt(expected_price) }}<span class="h6 m-0 pl-1 font-weight-600 ">元</span>
              </div>
            </div>
          </div>

          <div v-if="is_stock">
            <hr class="my-3">
            <div class="row m-0 ">
              <div class="col-6 text-custom-text font-weight-600">先前預訂下單數量</div>
              <div class="col-6 text-right text-custom-text">{{ last_order_amount }} PCS</div>
            </div>
            <div class="mt-3"/>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" size="lg" class="btn btn-main-color w-25" style=""
                  v-text="'下單'"
                  @click="clickOrder"/>
        </div>

      </div>
    </div>
  </div>
</template>
<success-dialog
  :show.sync="successShow"
  :title="successTitle"
  :message="successMessage"
  :meta="successMeta"/>


<script>
import TagItem from "@/views/components/elements/TagItem";
import WatermarkImage from "@/components/WatermarkImage.vue";
import {generateUuidNo, getMediaUrl, wait} from "@/util/helpers";
import {checkError} from "@/util/error_handler";
import {updateOrderCommodity} from "@/util/http_api";
import * as formatter from "../../../util/formatter";
import Dialog from "@/components/Dialog.vue";


export default {
  name: "CommodityImageDialog",
  components: {
    Dialog,
    TagItem: TagItem,
    WatermarkImage,
  },
  props: {
    dataTarget: {
      type: String,
      default: "exampleModal",
    },
    commodity_id: Number,
    catalog_id: Number,
    title: {
      type: String,
      default: ''
    },
    note: {
      type: String,
      default: ''
    },
    img: Object,
    tag_list: {
      type: Array,
      default: () => [],
    },
    is_new: {
      type: Boolean,
      default: false,
    },
    is_stock: {
      type: Boolean,
      default: false
    },
    last_order_amount: {
      type: Number,
      default: 0,
    },
    official_monetary_type_id: {
      type: Number,
      default: 0,
    },
    sell_monetary_type_id: {
      type: Number,
      default: 0,
    },
    official_price: {
      type: Number,
      default: 0,
    },
    commodity_price_calc_type: String,
    sell_price: {
      type: Number,
      default: 0,
    },
    discount: {
      type: Number,
      default: 1,
    },
    is_combine_buy: {
      type: Boolean,
      default: false,
    },
    combine_buy_amount: {
      type: Number,
      default: 0,
    },
    combine_buy_discount: {
      type: Number,
      default: 1,
    },
    exchange_rate: {
      type: Number,
      default: 0,
    },
    amount: {
      type: Number,
      default: 0,
    },
    additional_amount: {
      type: Number,
      default: 0,
    },
    unit_list: Array,
    unit_type: Object,
  },
  data() {
    return {
      selector: '',
      operate_amount: 1,
      // unit_list: [
      //   {
      //     text: '盒',
      //     amount: 6
      //   },
      //   {
      //     text: '箱',
      //     amount: 24
      //   },
      //   {
      //     text: 'PCS',
      //     amount: 1
      //   },
      // ],
      operate_unit_type: {},
      total_amount: 0,
      total_price: 0,
      discount_price: 0,
      combine_buy_discount_price: 0,
      expected_price: 0,
      // success dialog props (removed - using global success store)
    };
  },
  beforeMount() {
    const randomNum = generateUuidNo();
    this.selector = `order_dialog_item_${randomNum}`;
  },
  created() {
    this.operate_amount = this.amount;
    this.operate_unit_type = JSON.parse(JSON.stringify(this.unit_type));
    this.calculateTotalAmount();
  },
  methods: {
    getMediaUrl,
    ceil: formatter.ceil,
    floor: formatter.floor,
    formatPrice: formatter.formatPrice,
    formatMonetaryTypeName: formatter.formatMonetaryTypeName,
    formatMonetaryTypePrefix: formatter.formatMonetaryTypePrefix,
    formatMonetaryTypeSuffix: formatter.formatMonetaryTypeSuffix,
    formatPriceCalculateType: formatter.formatPriceCalculateType,
    // 匯率跟一般金額不同，2 位小數會把 0.206 這種值四捨五入成 0.21，跟後台顯示的原始
    // 數字對不起來；固定顯示 3 位、不加千分位，跟後台看到的數字一致。
    fmtRate(num) {
      if (num === null || num === undefined || isNaN(num)) return '0.000';
      return Number(num).toFixed(3);
    },
    fmt(num) {
      if (num === null || num === undefined || isNaN(num)) return '0.00';
      const rounded = Math.round(Number(num) * 100) / 100;
      const parts = rounded.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    },
    add() {
      this.processCount(1);
    },
    dec() {
      this.processCount(-1);
    },
    processCount(add) {
      let unit_count = this.operate_unit_type.unit_count;
      let count = Math.floor(this.operate_amount / unit_count) + add;
      count = Math.min(Math.max(count, 0), Math.floor(999 / unit_count));
      this.operate_amount = count * unit_count;
      this.calculateTotalAmount();
    },
    onOperateAmountInput(e) {
      // normalize immediately and recalc totals
      this.normalizeOperateAmount();
      this.calculateTotalAmount();
    },
    onOperateAmountBlur(e) {
      this.normalizeOperateAmount();
      this.calculateTotalAmount();
    },
    onOperateAmountEnter(e) {
      this.normalizeOperateAmount();
      this.calculateTotalAmount();
    },
    normalizeOperateAmount() {
      let val = Number(this.operate_amount) || 0;
      const unit = (this.operate_unit_type && this.operate_unit_type.unit_count) ? this.operate_unit_type.unit_count : 1;
      const max = Math.floor(999 / unit) * unit;
      val = Math.max(0, Math.min(val, max));
      val = Math.floor(val / unit) * unit;
      this.operate_amount = val;
    },
    selectUnit(item) {
      this.operate_unit_type = item;
      this.calculateTotalAmount();
    },
    calculateTotalAmount() {
      this.total_amount = this.operate_unit_type.amount * this.operate_amount;
      this.total_price = this.total_amount * this.official_price;
      const d = this.discount > 1 ? this.discount / 100 : this.discount;
      let p = 0;
      let combine_price = 0;
      switch (this.commodity_price_calc_type) {
        case 'sale_price_discount':
          p = this.official_price * d;
          this.discount_price = this.floor(this.total_amount * d, 2);
          combine_price = this.ceil(p * this.total_amount, 2);
          break;
        case 'exchange_rate_discount':
          p = this.official_price * this.exchange_rate * d;
          this.discount_price = this.floor(this.total_price * (1 - d), 2);
          combine_price = this.ceil(this.total_price * d, 2);
          break;
        case 'sell_price':
          p = this.ceil(this.sell_price, 2);
          this.total_price = this.total_amount * p;
          combine_price = this.total_price;
          break;
      }
      console.log(`is_combine_buy : ${this.is_combine_buy}, combine_buy_amount : ${this.combine_buy_amount}, combine_buy_discount : ${this.combine_buy_discount}`);
      if (this.is_combine_buy && this.combine_buy_amount > 0) {
        this.combine_buy_discount_price = this.floor(combine_price * (1 - this.combine_buy_discount), 2)
        this.expected_price = this.ceil(p * this.combine_buy_discount, 2) * this.total_amount;
      } else {
        this.combine_buy_discount_price = 0;
        this.expected_price = this.ceil(p, 2) * this.total_amount;
      }
    },
    cancel() {
      // console.log("cancel ");
    },
    async clickOrder() {
      // console.log("clickOrder ");
      try {
        await this.$store.dispatch('showLoading');
        // await wait(1000);
        let response = await updateOrderCommodity({
          catalog_id: this.catalog_id,
          commodity_id: this.commodity_id,
          operate_amount: this.operate_amount,
          is_combine_buy: this.is_combine_buy,
          combine_buy_amount: this.combine_buy_amount,
        });
        await this.$store.dispatch('hideLoading');
        // TODO API - debug: print full response for investigation
        try {
          console.log('updateOrderCommodity full response:', response);
          console.log('response.data.error:', response && response.data && response.data.error);
          console.log('response.error:', response && response.error);
          try { console.log('full response JSON:', JSON.stringify(response, null, 2)); } catch (err) { console.log('stringify response error', err); }
        } catch (err) {
          console.log('logging response failed', err);
        }
        if (checkError(this.$bvModal, response)) {
          // dispatch global success dialog with optional order id if present
          try {
            const orderId = (response && response.data && (response.data.order_id || response.data.id))
              || response.order_id
              || response.id
              || null;
            // Determine message based on whether this was an update, removal (set to 0), or a new order
            const prevAmount = (this.amount !== undefined && this.amount !== null) ? Number(this.amount) : 0;
            const newAmount = Number(this.operate_amount || 0);
            const isUpdate = prevAmount > 0;
            const isRemoved = newAmount === 0;
            let defaultMsg;
            if (isRemoved) {
              defaultMsg = '訂單項目已移除';
            } else if (isUpdate) {
              defaultMsg = '訂單數量修改成功';
            } else {
              defaultMsg = '下單成功';
            }
            const msg = (response && response.message) ? response.message : defaultMsg;
            const meta = { orderId, previousAmount: prevAmount, newAmount: newAmount };
            this.$store.dispatch('success/show', { msg: msg, meta: meta });
            console.debug('dispatched success/show, store state now:', this.$store.state.success);
          } catch (err) {
            console.debug('dispatch success failed', err);
          }
          this.$emit('update', this.operate_amount, this.expected_price);
          $(`#${this.dataTarget}`).modal('hide');
        }
      } catch (e) {
        // print error + response for investigation
        console.error('updateOrderCommodity threw:', e);
        try { console.log('e.response:', e.response); } catch (err) { console.log('cannot log e.response', err); }
        try { console.log('e.response JSON:', JSON.stringify(e.response, null, 2)); } catch (_) {}
        await this.$store.dispatch('hideLoading');
        if (e.response !== undefined) {
          checkError(this.$bvModal, e.response);
        }
      }
    },
  }
}
</script>

<style scoped>

.grid-gap {
  grid-gap: 10px;
}

.quantity-input {
  max-width: 120px;
  padding: 0.25rem 0.5rem;
  background: transparent;
  border: 0;
  box-shadow: none;
  text-align: center;
  -moz-appearance: textfield;
}
.quantity-input::-webkit-outer-spin-button,
.quantity-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.quantity-input:focus {
  outline: none;
}

.unit-readonly-btn {
  cursor: not-allowed;
}
</style>
